import MainLayout from "../../layout/MainLayout";
import OverviewSection from "../../components/OverviewSection";
import FilterSection from "../../components/FilterSection";
import DataTable from "../../common/Tables/DataTable";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { actionPost, getApi } from "../../services/api";
import useExpiredToken from "../../utils/useExpiredToken";
import { getCallTableColumns, ShowData } from "../../utils/ShowData";
import { processEncryptedResponse } from "../../utils/ResponseDecreypt";
import AssignedCallDetails from "../../components/models/AssignedCallDetails";
import { filterDataFunc, QA_ROLES } from "../../constant";

const Dashboard = () => {
  const [data, setData] = useState([]);
  const [overviewData, setOverviewData] = useState(null);
  const token = useSelector((state) => state.auth.jwtToken);
  const { searchText } = useSelector((state) => state.search);
  const expireToken = useExpiredToken();
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const role = useSelector((state) => state.auth.role);
  const [selectedRow, setSelectedRow] = useState(null);
  const userZone = useSelector((state) => state.auth.zone);
  const [zone, setZone]=useState()
  const columns = getCallTableColumns((record) => {
    setSelectedRow(record);
    setIsDetailsModalOpen(true);
  });
  //   const zoneOptions = [
  //   { value: "HA", label: "Zone HA", id:1 },
  //   { value: "DR", label: "Zone DR", id:2 },
  //   { value: "Bangalore_Treline", label: "Bangalore Treline", id:3 },
  //   { value: "Bangalore_Cimmons", label: "Bangalore Cimmons", id:4 },
  //   { value: "GUR-TRELINE", label: "Treline Gurgaon", id:5 },
  //   { value: "I-Collect", label: "I-Collect", id:6 },
  //   { value: "Samavesh", label: "Samavesh", id:7 },
  // ];

  const zoneOptions = [
    // { value: "HA", label: "Zone HA", id:1 },
    // { value: "DR", label: "Zone DR", id:2 },
    { value: "BLR-TRELINE", label: "Bangalore Treline", id: 3 },
    { value: "Bangalore_Cimmons", label: "Bangalore Cimmons", id: 4 },
    { value: "GUR-TRELINE", label: "Treline Gurgaon", id: 5 },
    { value: "NOIDA-ICOLLECT", label: "Noida I-Collect", id: 6 },
    { value: "GUR-SAMAVESH", label: "GUR Samavesh", id: 7 },
  ];

  // const fetchData = async () => {
  //   const res = await actionPost("calls/summary", token, "READ_ALL", {}, expireToken);
  //   const data = await processEncryptedResponse(res);

  //   if (data) {
  //     setData(data);
  //   }
  // };

  const fetchOverview = async () => {
    const res = await getApi("calls/overview", token, expireToken);
    const data = await processEncryptedResponse(res);
    if (data) {
      setOverviewData(data);
    }
  };

  const mappedData = data?.map((item) => ShowData(item, QA_ROLES.includes(role)));

  const filteredData = filterDataFunc(mappedData, searchText);

  useEffect(() => {
    // fetchData();
    fetchOverview();
  }, []);

  const handleCancel = () => {
    setIsDetailsModalOpen(false);
  };

  useEffect(() => {
    if(role=='qualitylead'){
    const userZoneData=zoneOptions.find(item=>item?.id==userZone)
    setZone(userZoneData?.value)
    }
  },[])

  return (
    <>
      <>
        <div className="container-fluid">
          <div className="">
            {role !== 'qualitylead' && (
        <OverviewSection overviewData={overviewData} />
        )}
            {/* <div>
              <FilterSection />
            </div> */}
          </div>
          <DataTable
            updatedColumns={columns}
            callApiArgs={{
              queryParams: role=='qualitylead'?{zone: zone || undefined}:{},
              endpoint: "calls/summary",
              bodyData: {
                action: "READ_ALL",
                input: {},
              },
              apiMethod: "post",
              dependencies: [zone],
            }}
          />
        </div>
      </>
      <AssignedCallDetails
        open={isDetailsModalOpen}
        handleCancel={handleCancel}
        formData={selectedRow}
      />
    </>
  );
};

export default Dashboard;
